import { PropsWithChildren, TableHTMLAttributes } from 'react';
import classNames from 'classnames';
import className from './layout-table-head.module.css';

export default function TableHead<T extends HTMLTableSectionElement>({
  children,
  ...props
}: PropsWithChildren<TableHTMLAttributes<T>>) {
  return (
    <thead
      {...props}
      className={classNames(
        className['bl-table-head'],
        {
          [className['no-border']]: props.border === 0,
        },
        props.className
      )}
    >
      {children}
    </thead>
  );
}
